import qqSvg from '/src/img/qq.svg'
import wechatSvg from '/src/img/wechat.svg'
import appleSvg from '/src/img/apple.svg'

// 导入多语言配置数据
function loadLocaleMessages () {
  const locales = require.context(
    './i18n',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  for (const key of locales.keys()) {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = {
        ...locales(key)
      }
    }
  }
  return messages
}
export const i18nData = loadLocaleMessages()

// 时间戳
export function getTimestamp (msec) {
  msec = !msec && msec !== 0 ? msec : 1
  return parseInt((new Date()).valueOf() / msec, 10)
}

//加载样式文件
export function loadStyle (src, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var style = document.createElement('link')
  // console.log(global);

  style.rel = 'stylesheet'
  style.href = src

  if (!('onload' in style)) {
    style.onreadystatechange = function () {
      if (this.readyState !== 'complete' && this.readyState !== 'loaded') return
      this.onreadystatechange = null
      cb(style)
    }
  }

  style.onload = function () {
    this.onload = null
    cb(style)
  }

  head.appendChild(style)
}
//加载js文件
export function loadScript (src, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  cb = cb || function () { }

  script.type = 'text/javascript'
  script.src = src

  if (!('onload' in script)) {
    script.onreadystatechange = function () {
      if (this.readyState !== 'complete' && this.readyState !== 'loaded') return
      this.onreadystatechange = null
      cb(script)
    }
  }

  script.onload = function () {
    this.onload = null
    cb(script)
  }

  head.appendChild(script)
}
/**
 * 防抖函数，返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
 *
 * @param  {function} func        回调函数
 * @param  {number}   wait        表示时间窗口的间隔
 * @param  {boolean}  immediate   设置为ture时，是否立即调用函数
 * @return {function}             返回客户调用函数
 */
export function debounce (func, wait = 50, immediate = true) {
  let timer, context, args

  // 延迟执行函数
  const later = () => setTimeout(() => {
    // 延迟函数执行完毕，清空缓存的定时器序号
    timer = null
    // 延迟执行的情况下，函数会在延迟函数中执行
    // 使用到之前缓存的参数和上下文
    if (!immediate) {
      func.apply(context, args)
      context = args = null
    }
  }, wait)

  // 这里返回的函数是每次实际调用的函数
  return function (...params) {
    // 如果没有创建延迟执行函数（later），就创建一个
    if (!timer) {
      timer = later()
      // 如果是立即执行，调用函数
      // 否则缓存参数和调用上下文
      if (immediate) {
        func.apply(this, params)
      } else {
        context = this
        args = params
      }
      // 如果已有延迟执行函数（later），调用的时候清除原来的并重新设定一个
      // 这样做延迟函数会重新计时
    } else {
      clearTimeout(timer)
      timer = later()
    }
  }
}

// 第三方登录基础数据配置
export let thirdConf = {
  qq: {
    platform: 2,
    icon: qqSvg,
    bind: false
  },
  wechat: {
    platform: 3,
    icon: wechatSvg,
    bind: false
  },
  apple: {
    platform: 15,
    icon: appleSvg,
    bind: false
  }
}

// 主组件全局基本配置
export let global = {
  env: 'dev',
  lang: 'zh-CN',
  title: '',
  titleShow: true,
  weixinShow: false,
  passwordShow: true,
  'no-passwordShow': true,
  thirdregisterShow: true,
  thirdconnectShow: true,
  appId: '', // 应用id
  tenantId: '', // 租户标识
  appSecret: '', // 应用密钥
  defaultMode: 'no-password', // 默认初始显示的登录方式， password ：密码， weixin ：微信， no-password ：免登陆
  currentMode: '',    // 当前登录模式
  loginType: 'phone', // 登录账号类型
  loginLink: './login.html',     // 登录页面地址
  thirdPartys: './thirdpartyLogin.html',
  registerLink: './register.html',  // 注册页面地址
  resetPwdLink: './resetpassword.html',  // 重置密码页面地址
  registerStep: false,
  logoutObj: {},//需要注销退出登录的必传参数
  accessToken: '',//需要CheckToken的必传参数
  typeSupport: 0, // 注册、密码重置 Number  0只支持邮箱，1只支持手机号，2手机号&邮箱；默认邮箱
  agreementShow: true, // 是否显示隐私协议等
  resetName: '',       // 需要重置密码的账号, 传值代表重置修改该帐号的密码
  cancelName: '',      // 需要注销的账号, 传值代表注销该帐号
  errorColor: 'red', // 输入框错误提示颜色
  inputsize: 'normal', // 默认, 输入框大小 ，large , normal, small
  NECaptcha: {// 易盾验证码配置
    mode: 'float',  //显示模式
  },
  publicKey: '',
  errorCount: 0,   // 密码登录输入错误次数
  thirdParty: {
    show: false,
    from: location.href,//指定第三方返回的地址
    // from: location.pathname == '/test/login.html'?`${location.origin}/test/thirdpartyLogin.html` : location.href,
    source: 3,
    types: Object.keys(thirdConf) //['qq', 'apple']//
  }
}

// 获取当前调用模式下表单元素DOM
export function inputEle (name) {
  // console.log(name);
  return name !== 'captcha' ? $('.' + global.currentMode + '-form input[name=' + name + ']') : $('#' + global.currentMode + '-captcha')
}
// ajax请求成功状态code集
export let ajaxSuccessCode = [1, 200]

// 正则
export const regObj = {
  phone: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
  mail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,16}$/,
}
// 账号中间部分*代替
export function accountHidden (str) {
  // /(.{5}).+(.{2}.+)/g // phone
  let reg = regObj.phone.test(str) ? /^(\d{3})\d*(\d{4})$/ : /(.{1}).+(.{1}@.+)/g

  return str.replace(reg, '$1****$2')
}

// 基本数据配置
const config = {
  resourceURL: '', //'http://10.88.80.102:8080',  // 项目所在服务器地址
  resourceDIR: '/auth/dist/',  // 项目所在服务器文件夹路径
  styleFile: 'account.min.css' + '?t=' + getTimestamp(1 * 60 * 1000), // 打包成的样式文件
  envInfoList: [
    // src 对接
    {
      appId: '60071610591068063',
      tenantId: 'tcl',
      appSecret: '8b1448d7d9eef5c3c9aff558d5d67f2abf988e56d1a4a61d839768ab9cc1d02f'
    },
    {
      appId: '13411610591630676',
      tenantId: 'tcl',
      appSecret: '77611660c2e9236422bfdbf221b3c44c071a0b964a87cf7dd552799e14b6977f'
    },
    {
      appId: '94761610591567905',
      tenantId: 'tcl',
      appSecret: '9fb9ca0ea06a1cdb2c709a3229518df9cfb6e798bbfb2018e9c52b042a4cffdc'
    },
    {
      appId: '10091610591686612',
      tenantId: 'tcl',
      appSecret: 'f0da2370ccfee4f3d05cf22b67160be4bd11e99fc8a414a13d282cc50cb28ab5'
    },

    // iot 对接
    {
      appId: '63271631151611417',
      tenantId: 'tcl',
      appSecret: '5c79242899b87fe8f376d3410760492d0aad76086acb0831851a209a4eb3509f'
    },
    {
      appId: '90901631151869222',
      tenantId: 'tcl',
      appSecret: '778e1cc41b31baf63cebd916457ac1a5826ac18495ddcf657d37eb798128a5a3'
    },
    {
      appId: '16831631151952753',
      tenantId: 'tcl',
      appSecret: 'f340edea11233702c787c9f31a23426dead7eb2622525f749613b136c4d2169b'
    },
    {
      appId: '98061631151698543',
      tenantId: 'tcl',
      appSecret: 'd904c353821edd7ca5a6adc79af8ecb5755e2b7d3250e15f31a17a1fa905df92'
    },

  ],
  interface: {   // 接口服务器地址
    oversea: {// 海外
      dev: {
        origin: 'https://inn-test.tclo2o.cn',// 'http://10.120.28.19:8081', //'', //
        clientId: '99999999',
      },
      uat: {
        origin: 'https://inn-test.tclo2o.cn',
        clientId: '99999999',
      },
      sit: {
        origin: 'https://inn-test.tclo2o.cn',
        clientId: '99999999',
      },
      prod: {
        origin: 'https://in.account.tcl.com',
        clientId: '54148614',
      },
      login: '/account/loginWithNetEase',
      quickLogin: '/account/quickLogin',
      sendVerifyCode: '/common/sendVerifyCodeWithNetEase',
    },
    internal: {// 国内
      dev: {
        origin: 'https://account-dev.tcljd.com',// 'http://10.120.28.19:8081', //'', //,
        appId: '60071610591068063',
        tenantId: 'tcl',
        appSecret: '8b1448d7d9eef5c3c9aff558d5d67f2abf988e56d1a4a61d839768ab9cc1d02f'
      },
      uat: {
        origin: 'https://account-uat.tcljd.com',
        appId: '13411610591630676',
        tenantId: 'tcl',
        appSecret: '77611660c2e9236422bfdbf221b3c44c071a0b964a87cf7dd552799e14b6977f'
      },
      sit: {
        origin: 'https://account-sit.tcljd.com',
        appId: '94761610591567905',
        appSecret: '9fb9ca0ea06a1cdb2c709a3229518df9cfb6e798bbfb2018e9c52b042a4cffdc',
        tenantId: 'tcl'
      },
      prod: {
        origin: 'https://cn.account.tcl.com',
        appId: '10091610591686612',
        tenantId: 'tcl',
        appSecret: 'f0da2370ccfee4f3d05cf22b67160be4bd11e99fc8a414a13d282cc50cb28ab5'
      },
      login: '/auth/auth/loginByNetEase',
      validateToken: '/auth/auth/validateToken',
      logout: '/auth/auth/signOut',
      quickLogin: '/auth/auth/quickLogin',
      thirdPartyLogin: '/auth/thirdParty/login',
      thirdPartyBindByValid: '/auth/thirdParty/bindUserByValidCode',
      thirdPartyBindByUser: '/auth/thirdParty/bindUser',
      //   thirdPartyBind: '/auth/thirdParty/bindUserNoValidCode',
      queryThirdPartyInfos: '/auth/thirdParty/queryThirdPartyInfos',
      bindThirdParty: '/auth/thirdParty/bindThirdParty',
      unbindThirdParty: '/auth/thirdParty/unbindUser',
      sendVerifyCode: {
        sms: '/captcha/captcha/smsCaptchaByNetEase',
        mail: '/captcha/captcha/emailCaptchaByNetEase'
      },
      imageCaptcha: '/captcha/captcha/imageCaptcha', // 图片验证码
      quickRegister: '/auth/auth/quickRegister',
      registerNoCaptcha: '/auth/auth/registerNoCaptcha',
      resetPwdCheckCode: '/auth/account/forget/check/verifyCode',
      updatePwd: '/auth/account/updatePwdBySafeCode',
      deleteByPassword: '/auth/account/deleteByPassword',
      publicKey: '/auth/common/publicKey',
    },
  },
  jQueryURL: 'https://lib.baomitu.com/jquery/3.5.1/jquery.min.js',   // jQuery CDN
  ZeptoURL: '//zeptojs.bootcss.com/zepto.min.js',   // zepto CDN
  NECaptchaURL: 'https://cstaticdun.126.net/load.min.js' + '?t=' + getTimestamp(1 * 60 * 1000),// 时长1分钟，建议时长分钟级别
  jsencryptURL: 'https://passport.jd.com/new/js/jsencrypt.min.js',   // jsencrypt CDN
}
export default config